export interface NotifyMePayload {
    data: {
        type: string,
        id: string,
        attributes: {
            endpoint: string,
            email: string,
        },
        relationships: {
            conditions: {
                data: [
                    {
                        id: string,
                        type: string,
                    }
                ]
            }
        }
    },
    included: [
        {
            id: string,
            type: string,
            attributes: {
                name: string,
                value: number | string,
            }
        }
    ]
}
export interface ContactVenuePayload {
    data: {
        type: string,
        id: string,
        attributes: {
            venue: number,
            contacted: boolean,
        }
    }
}
export const CLAIM_VENUE_TEMPLATE = "pf-claim-venue";
export const CONTACT_VENUE_SUCCESS_TEMPLATE = "pf-successful-contact-venue";
export const CONTACT_VENUE_FAIL_TEMPLATE = "pf-unable-to-contact-venue";
